module.exports = __webpack_public_path__ + "3954a1d1c591ce9cd27e2c92f22e3e4b.svg";